import React from 'react';
import './PeopleTable.css';

interface Person {
  name: string;
  tableId: number;
  seatNumber: number;
}

interface PeopleTableProps {
  people: Person[];
}

const PeopleTable: React.FC<PeopleTableProps> = ({ people }) => {
  const getTableName = (tableId: number) => {
    if (tableId <= 4) {
      return `${tableId}`;
    } else {
      return 'Head Table';
    }
  };

  return (
    <div className="people-table-container">
      <h2>Seat Assignments</h2>
      <div className="table-wrapper">
        <table className="people-table">
          <thead>
            <tr>
              <th>Name</th>
              <th>Table</th>
              <th>Seat</th>
            </tr>
          </thead>
          <tbody>
            {people.map((person, index) => (
              <tr key={index}>
                <td>{person.name}</td>
                <td>{getTableName(person.tableId)}</td>
                <td>{person.seatNumber}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default PeopleTable;
